import { ModelBase } from "Core/Models";
import { action, observable } from "mobx";

export class ReservationType1FinancialIncentiveTypesModel extends ModelBase<ReservationType1FinancialIncentiveTypesModel, ReservationType1FinancialIncentiveTypesDTO> {
    //#region Properties
    @observable
    public id: string | undefined = "";

    @observable
    public displayName: string = "";

    @observable
    public type: number = 0;

    @observable
    public ordinal: number = 0;
    //#endregion roperties

    @action
    public fromDto = (reservationType1FinancialIncentiveTypesDto: ReservationType1FinancialIncentiveTypesDTO) => {
        this.id = reservationType1FinancialIncentiveTypesDto.id;
        this.displayName = reservationType1FinancialIncentiveTypesDto.displayName;
        this.type = reservationType1FinancialIncentiveTypesDto.type;
        this.ordinal = reservationType1FinancialIncentiveTypesDto.ordinal;
    };

    public toDto = (): ReservationType1FinancialIncentiveTypesDTO => {
        return {
            id: this.id,
            displayName: this.displayName,
            type: this.type,
            ordinal: this.ordinal,
        };
    };
}

export interface ReservationType1FinancialIncentiveTypesDTO {
    id: string | undefined;
    displayName: string;
    type: number;
    ordinal: number;
}
